import { render, staticRenderFns } from "./intelBrandList.vue?vue&type=template&id=e1765c58&scoped=true&"
import script from "./intelBrandList.vue?vue&type=script&lang=js&"
export * from "./intelBrandList.vue?vue&type=script&lang=js&"
import style0 from "./intelBrandList.vue?vue&type=style&index=0&id=e1765c58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1765c58",
  null
  
)

export default component.exports